import React, { Component } from 'react'
import './Ballot.css'
import PoliticalParty from './PoliticalParty'
import afpLogo from './img/afplogo.png'
import jpcLogo from './img/jpclogo.png'
import base from '../../base'
import ResultsModal from './ResultsModal';

export default class Ballot extends Component {
    state = {
        votes: {
            jpc: 0,
            afp: 0
        },
        showResults: false
    }

    componentDidMount() {
        this.ref = base.syncState('votes', {
            context: this,
            state: 'votes'
        })
    }

    componentWillUnmount() {
        base.removeBinding(this.ref)
    }

    castVoteFor = (party) => {
        let votes = {
            jpc: 0,
            afp: 0
        }
        votes.jpc = this.state.votes.jpc
        votes.afp = this.state.votes.afp

        votes[party]++

        this.setState({
            votes
        })
        this.toggleResultsModal()
    }

    toggleResultsModal = () => {
        let showResults = ! this.state.showResults
        this.setState({
            showResults
        })
    }

    render() {
        return (
            <section className="Ballot">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12">
                            <h2 className="text-center">You Decide!</h2>
                            <hr />
                        </div>
                        <div className="col-sm-12 d-flex">
                            <ResultsModal 
                                show={this.state.showResults} 
                                close={this.toggleResultsModal} 
                                votes={this.state.votes}
                            />
                            <PoliticalParty
                                name="Asun For Progress"
                                id="afp"
                                manifesto="Asun As Possible"
                                icon={afpLogo}
                                onClick={this.castVoteFor}
                            />
                            <PoliticalParty
                                name="Jollof People's Congress"
                                id="jpc"
                                manifesto="I Eat. You Eat. We All Eat"
                                icon={jpcLogo}
                                onClick={this.castVoteFor}
                            />
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}
